/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_State_BlockedInputs */

const en_inbox_state_blocked = /** @type {(inputs: Inbox_State_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting for you`)
};

const id_inbox_state_blocked = /** @type {(inputs: Inbox_State_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menunggu Anda`)
};

/**
* | output |
* | --- |
* | "waiting for you" |
*
* @param {Inbox_State_BlockedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_state_blocked = /** @type {((inputs?: Inbox_State_BlockedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_State_BlockedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_state_blocked(inputs)
	return en_inbox_state_blocked(inputs)
});